import React, { Component } from "react";
import { Layout } from "antd";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

import "./index.less";

export default class BaseLayout extends Component {
  render() {
    return (
      <Layout className="nano-layout">
        <Navbar/>
        <Layout>
          <Sidebar />
          <Layout.Content className="nano-layout-content">
            <div className="nano-main">
              {this.props.children}
            </div>
          </Layout.Content>
        </Layout>
      </Layout>
    );
  };
}
